import React from 'react';
import { SiteFooter } from 'components/Footer.style.js';
import { FlexContainer } from 'theme/Grid';

const Footer = () => {
  return (
    <SiteFooter>
      <FlexContainer>
        <p>&copy; Copyright Edward Smith 2018</p>
      </FlexContainer>
    </SiteFooter>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js